"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
const theme_palette_1 = require("../../components/theme.palette");
exports.CSS = {
    container: 'c-ValidationNotification',
    section: 'c-ValidationNotification__section',
    sectionTitle: 'c-ValidationNotification__sectionTitle',
    content: 'c-ValidationNotification__content',
    modal: 'c-ValidationNotification__modal',
    message: 'c-ValidationNotification__message',
    categorySection: 'c-ValidationNotification__categorySection',
    categorySectionError: 'c-ValidationNotification__categorySection--error',
    categorySectionWarning: 'c-ValidationNotification__categorySection--warning',
    categorySectionInfo: 'c-ValidationNotification__categorySection--info',
    categoryHeading: 'c-ValidationNotification__categoryHeading',
};
exports.Style = {
    [exports.CSS.container]: {
        color: theme_1.DefaultTheme.font.color.primary,
    },
    [exports.CSS.section]: {
        'padding-bottom': theme_1.DefaultTheme.space(1),
    },
    [exports.CSS.sectionTitle]: {
        'font-weight': theme_1.DefaultTheme.font.weight.bold,
    },
    [exports.CSS.content]: {
        'list-style': 'none',
        margin: 0,
    },
    [exports.CSS.modal]: {
        'min-width': '650px',
    },
    [exports.CSS.categorySection]: {
        'margin-bottom': theme_1.DefaultTheme.space(3),
        padding: theme_1.DefaultTheme.space(2),
        'border-left': '4px solid transparent',
        'border-radius': '2px',
    },
    [exports.CSS.categorySectionError]: {
        'border-left-color': (0, theme_1.rgba)(theme_palette_1.ColorPaletteRed.A700),
        'background-color': (0, theme_1.rgba)(theme_palette_1.ColorPaletteRed.A700, 0.05),
    },
    [exports.CSS.categorySectionWarning]: {
        'border-left-color': (0, theme_1.rgba)(theme_palette_1.ColorPaletteOrange.C700),
        'background-color': (0, theme_1.rgba)(theme_palette_1.ColorPaletteOrange.C700, 0.05),
    },
    [exports.CSS.categorySectionInfo]: {
        'border-left-color': (0, theme_1.rgba)(theme_palette_1.ColorPaletteGreen.A300),
        'background-color': (0, theme_1.rgba)(theme_palette_1.ColorPaletteGreen.A300, 0.05),
    },
    [exports.CSS.categoryHeading]: {
        'font-weight': theme_1.DefaultTheme.font.weight.bold,
        'font-size': '16px',
        'margin-bottom': theme_1.DefaultTheme.space(2),
    },
};
//# sourceMappingURL=validation.notification.style.js.map